import { useContext, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { HubDetailsContext } from '../../context/hub-details';
import { Box, Container, Grid, Link, Stack, Typography, useMediaQuery } from '@mui/material';
import parse from 'html-react-parser';
import gaiaTheme from '../../../theme';


const WebsiteFooter = () => {

  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(gaiaTheme.breakpoints.down('md'));


  const hub = useContext(HubDetailsContext);
  const [termsLink, setTermsLink] = useState(null);
  const [privacyLink, setPrivacyLink] = useState(null);
  const [footerDetails, setFooterDetails] = useState({
    column_one_html: '',
    column_two_html: '',
    column_three_html: ''
  });

  useEffect(() => {
    setTermsLink(hub.hubDetails?.organisation_settings?.terms_and_conditions_link);
    setPrivacyLink(hub.hubDetails?.organisation_settings?.privacy_policy_link);
    setFooterDetails({
      column_one_html: hub.hubDetails.hub_footer?.column_one_html,
      column_two_html: hub.hubDetails.hub_footer?.column_two_html,
      column_three_html: hub.hubDetails.hub_footer?.column_three_html
    });
  }, [hub.hubDetails]);

  return (<>

    {hub.hubDetails?.id === 11 && <>
      <Box
        sx={{
          width: '100%',
          marginTop: 'auto',
          backgroundColor: '#f5f5f5'
        }}
      >
        <Container maxWidth='lg' sx={{ pt: 12, pb: 12 }}>
          <Grid
            container
            direction='row'
            spacing={4}
          >
            <Grid item xs={12} md={8} lg={8}>
              <Stack direction={isMobileMode || isTablet ? 'column' : 'row'} alignItems={'flex-start'}>
                <Box sx={{ width: '25%', mr: '20%' }}>
                  <img src={`/north-east-combined-authority/NZNEE-Logo-Vertical-RGB.png`} style={{ textAlign: 'left' }} alt='logo' />
                </Box>
                <Box sx={{ width: '55%', height: '100%', mt: isTablet ? 6 : 0 }}>
                  <Stack direction={'column'} justifyContent={'space-between'} height={'100%'}>
                    <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }} gutterBottom>
                      <a style={{ color: 'inherit' }} href='mailto:info@netzeronortheastengland.co.uk'>info@netzeronortheastengland.co.uk</a>
                    </Typography>

                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                      © North East Combined Authority 2025.
                    </Typography>
                  </Stack>

                </Box>
              </Stack>
            </Grid>

            <Grid item xs={12} md={4} lg={4}>
              <Stack direction={'row'} alignItems={'center'}>

                <Box sx={{ width: isTablet ? '100%' : '50%' }}>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    <a style={{ color: 'inherit' }} href='https://www.netzeronortheastengland.co.uk/priorities'>Priorities</a>
                  </Typography>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    <a style={{ color: 'inherit' }} href='/hub/pages/privacy-policy'>Privacy and cookie policy</a>
                  </Typography>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    <a style={{ color: 'inherit' }} href='https://www.netzeronortheastengland.co.uk/contact'>Statement of intent</a>
                  </Typography>
                </Box>
                <Box sx={{ pl: 4, width: '50%' }}>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    <a style={{ color: 'inherit' }} href='/hub/pages/terms-and-conditions'>Terms and conditions</a>
                  </Typography>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    <a style={{ color: 'inherit' }} href='https://www.northeast-ca.gov.uk/terms-and-conditions'>Contact</a>
                  </Typography>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    <a style={{ color: 'inherit' }} href='https://www.northeast-ca.gov.uk/north-of-tyne-ca'>Transparency</a>
                  </Typography>
                </Box>
              </Stack>
            </Grid>

          </Grid>
        </Container>
      </Box>
    </>}

    {hub.hubDetails?.id !== 11 && <>

      {(footerDetails?.column_one_html || footerDetails?.column_two_html) &&
        <Box
          sx={{
            width: '100%',
            marginTop: 'auto',
            backgroundColor: 'primary.main'
          }}
        >
          <Container maxWidth='lg' sx={{ pt: 8, pb: 8 }}>
            <Grid
              container
              direction='row'
              spacing={4}
            >
              <Grid item xs={12} md={12} lg={6}>
                {footerDetails?.column_one_html && parse(footerDetails?.column_one_html)}
              </Grid>

              <Grid item xs={12} md={12} lg={6}>
                {footerDetails?.column_two_html && parse(footerDetails.column_two_html)}
              </Grid>

              {/* <Grid item xs={12} md={4} lg={4}>
            {footerDetails?.column_three_html && parse(footerDetails.column_three_html)}
          </Grid> */}
            </Grid>
          </Container>
        </Box>
      }
      {(footerDetails?.column_one_html || footerDetails?.column_two_html) &&
        <Box sx={{ backgroundColor: 'primary.dark' }}>
          <Container maxWidth='lg' sx={{ pt: 1, pb: 1 }}>
            <Stack direction='row' spacing={2} sx={{ width: '100%' }}>
              {termsLink && <Link to={termsLink} target="_blank" component={RouterLink} sx={{ color: '#fff', fontSize: '12px' }}>Terms and Conditions</Link>}
              {privacyLink && <Link to={privacyLink} target="_blank" component={RouterLink} sx={{ color: '#fff', fontSize: '12px' }}>Privacy Policy</Link>}
              <Link to='https://gaiacompany.io' target="_blank" component={RouterLink} sx={{ color: '#fff', fontSize: '12px', justifyContent: "flex-end", ml: "auto !important", mt: 0, float: "right" }}>Powered by Gaia Technologies</Link>
            </Stack>
          </Container>
        </Box>
      }</>

    }

  </>
  );
};

export default WebsiteFooter;